module.exports = "/assets/ffb801084d05e057b79463434e5bc473.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/5U.png
// module id = 1072
// module chunks = 0